module.exports = __webpack_public_path__ + "img/background-inactive.458e0834.png";